/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

//matches `^[\s\S]{0,10}$`
//groups: [max]   `max: 10`
const maxlengthRegex = /\^\[\\s\\S\]\{0,(\d+)\}\$/;

//matches `^anything{0,10}$`
//groups: [repeatedPattern, max]    `repeatedPattern: anything, max: 10`
const maxRegex = /^\^(.+?)\{0,(\d+)\}\$$/;

const maxWordsPatternContentWithoutMinMax =
    '(?:(?:[^\\s\\:\\!\\?\\;\\\u2026\\\u20ac]+)[\\s\\:\\!\\?\\;\\\u2026\\\u20ac]*)';
const maxWordsSeparators = '\\s.,:;?!&#%/*+='; //should be the same as in backend validation

/**
 * Check if this patternMask is a Maxlength patternMask generated by Autrhoring,
 * and if it is, return maxlength specified by this patternMask
 * @param {String} patternMask
 * @returns {Number?} maxlength if pattern is recognized, null if not
 */
export function tryParseMaxlength(patternMask) {
    if (patternMask) {
        const matches = patternMask.match(maxlengthRegex);
        if (matches && matches.length > 1) {
            return parseInt(matches[1], 10);
        }
    }
    return null;
}

/**
 * Check if this patternMask is a "Max words" patternMask generated by Authoring,
 * and if it is, return maxWords and word separators specified by this patternMask.
 * NB! word separators are hardcoded and aren't extracted from patternMask; this matches backend solution.
 * @param {String} patternMask
 * @returns {Object|null} - `{max: number, separators: string}`, or null if pattern is not recognized
 */
export function tryParseMaxWords(patternMask) {
    if (patternMask) {
        const matches = patternMask.match(maxRegex);
        if (matches && matches[1] === maxWordsPatternContentWithoutMinMax && matches[2]) {
            return {
                max: parseInt(matches[2], 10),
                separators: maxWordsSeparators
            };
        }
    }
    return null;
}
